import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { canChangeUsersWorkGroup } from '@shared/utils/AccessControl';
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { AddTeamMemberButton } from '@shared/ui/atoms/buttons/AddTeamMemberButton';
import { AddTeamMember } from '@features/whereabouts/pages/team-movements/components/AddTeamMember';
import { EditTeamControlsRow } from '@features/whereabouts/pages/team-movements/components/edit-team-row/EditTeamRow';
import { useScopedGroups } from '@features/whereabouts/hooks/useScopedGroups';
import { useWhereaboutsScope } from './WhereaboutsScopeContext';

// Sidebar actions that depend on what the page is showing:
// - followed groups: add a member to the user's own team
// - one team: add a member to / edit that team
// - one workgroup: add or remove members / rename it (company admins)
export function ScopeActions() {
  const dispatch = useDispatch();
  const { scope } = useWhereaboutsScope();
  const { teams, workGroups } = useScopedGroups(scope);
  const currentUser = useSelector(selectCurrentUser);

  if (scope.kind === 'team') {
    const team = teams[0];
    if (!team) return null;
    return (
      <ActionsColumn className="addTeamMember">
        <AddTeamMemberButton team={team} buttonStyle={'primary'} />
        <EditTeamControlsRow team={team} showTeamDetails={false} />
      </ActionsColumn>
    );
  }

  if (scope.kind === 'workgroup') {
    const tag = workGroups[0];
    if (!tag || !canChangeUsersWorkGroup(currentUser)) return null;
    const openMembersDialog = () => dispatch(openDialogWithPayload({
      payload: { tag },
      activeDialog: DialogIdentifiers.EditUsersInTagDialog,
    }));
    const openRenameDialog = () => dispatch(openDialogWithPayload({
      payload: { workgroup: tag },
      activeDialog: DialogIdentifiers.EditTagNameDialog,
    }));
    return (
      <ActionsColumn>
        <OutlineButton click={openMembersDialog} fullWidth={true} text={'edit-workgroup.add-or-remove-members'} />
        <OutlineButton click={openRenameDialog} fullWidth={true} text={'edit-workgroup.edit-workgroup-name'} style={{marginTop: 8}} />
      </ActionsColumn>
    );
  }

  return <AddTeamMember />;
}

const ActionsColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
`;
